var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "227px",
    height: "52px",
    viewBox: "0 0 227 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 51 223.266909 51 223.266909 0.849381818 0 0.849381818"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.77465625 0.551105455 4.7446875 0.551105455 4.7446875 31.5147418 0.77465625 31.5147418"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0.866968334 22.0030312 0.866968334 22.0030312 51.9999378 0 51.9999378"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LG-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LG-Web-top",
    transform: "translate(-97.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(97.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#050101",
    points: "84.5305653 44.87694 57.2701355 44.87694 57.2701355 7.32703091 66.7299702 7.32703091 66.7299702 38.6614309 84.5305653 38.6614309"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#050101",
    mask: "url(#mask-2)",
    points: "86.0826446 30.0250909 99.6614876 30.0250909 99.6614876 22.1785091 86.0826446 22.1785091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.897336,39.7307618 C138.998294,42.4829073 132.74203,45.6411982 124.808542,45.6411982 C111.381501,45.6411982 105.736145,37.7946164 105.736145,25.8216709 C105.736145,12.8806527 113.212377,6.56221636 125.011253,6.56221636 C131.92841,6.56221636 138.133765,10.2824345 141.490063,16.8549436 L131.725699,18.3840164 C130.046625,14.3067982 128.317567,12.77958 125.113997,12.77958 C120.484972,12.77958 115.450526,16.4979436 115.450526,26.0757436 C115.450526,34.9933255 119.162261,39.4256891 125.063088,39.4256891 C128.673005,39.4256891 131.419319,38.6106164 132.792939,37.8456164 L132.792939,31.3751073 L125.927617,31.3751073 L125.927617,25.1595982 L141.897336,25.1595982 L141.897336,39.7307618 Z",
    id: "Fill-12",
    fill: "#050101",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.899557,31.6297364 C157.915094,32.3938091 155.932417,34.3818818 155.932417,36.7761 C155.932417,38.5592455 156.847855,39.7303909 158.627821,39.7303909 C159.949607,39.7303909 161.576846,39.2222455 162.899557,38.2031727 L162.899557,31.6297364 Z M163.814995,44.8767545 C163.561375,44.5197545 163.357739,44.0116091 163.30683,43.5016091 L163.154102,43.5016091 C161.883226,44.3667545 159.54326,45.4878273 156.237871,45.4878273 C149.828879,45.4878273 146.726202,42.4306091 146.726202,37.4891727 C146.726202,32.1898091 150.388879,28.5215182 162.899557,26.7393 L162.899557,25.8723 C162.899557,23.2240091 162.238664,21.2878636 160.000516,21.2878636 C158.170565,21.2878636 157.306036,23.1720818 156.898764,24.8532273 L148.049838,24.3951545 C148.96435,20.3188636 151.812483,16.0404273 160.153243,16.0404273 C167.274036,16.0404273 171.902136,18.2306455 171.902136,27.0453 L171.902136,40.6984636 C171.902136,42.7876091 172.054863,44.1126818 172.766664,44.5197545 L172.766664,44.8767545 L163.814995,44.8767545 Z",
    id: "Fill-13",
    fill: "#050101",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.021078,10.4346927 L188.022731,10.4346927 L188.022731,16.7021291 L191.684483,16.7021291 L191.684483,22.4595655 L188.022731,22.4595655 L188.022731,33.8715109 C188.022731,37.4897291 188.480912,39.4258745 190.108152,39.4258745 C191.02359,39.4258745 191.83721,38.8648745 192.346301,38.4068018 L193.516284,44.2653109 C191.83721,44.9283109 190.20997,45.4883836 187.819094,45.4883836 C182.071921,45.4883836 179.021078,42.6360927 179.021078,35.7065836 L179.021078,22.4595655 L176.580218,22.4595655 L176.580218,16.7021291 L179.021078,16.7021291 L179.021078,10.4346927 Z",
    id: "Fill-14",
    fill: "#050101",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.011174,28.1651673 C213.552992,23.3767309 212.02757,21.2356582 209.89124,21.2356582 C207.907636,21.2356582 206.127669,22.8148036 205.720397,28.1651673 L214.011174,28.1651673 Z M205.720397,32.6494582 C206.07676,38.3048945 207.654017,40.34304 210.094876,40.34304 C212.02757,40.34304 213.248463,39.0179673 213.960264,36.7758218 L223.267372,37.0308218 C222.606479,39.0179673 221.334678,41.0551855 219.096529,42.7372582 C216.910215,44.4184036 214.011174,45.4884764 209.993058,45.4884764 C206.331306,45.4884764 202.821355,44.6734036 200.330512,42.1762582 C197.939636,39.83304 196.515107,36.1647491 196.515107,30.6113127 C196.515107,26.0250218 197.736,21.8986582 200.431405,19.35144 C202.618645,17.2622945 205.720397,16.0401491 209.942149,16.0401491 C213.603901,16.0401491 216.757488,17.0082218 219.147438,19.5035127 C222.199207,22.6627309 223.267372,27.0960218 223.267372,32.6494582 L205.720397,32.6494582 Z",
    id: "Fill-15",
    fill: "#050101",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E9A22F",
    points: "24 52 29 48.9469479 29 5.05210542 24 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#E9A22F",
    points: "38 9.34313111 32 6 32 47 38 43.6568689"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(39.375000, 10.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70496875,1.70361455 L0.77465625,0.551105455 L0.77465625,31.5147418 L2.70496875,30.3622327 C3.96778125,29.6087055 4.74496875,28.2151055 4.74496875,26.70616 L4.74496875,5.35968727 C4.74496875,3.85074182 3.96778125,2.45808727 2.70496875,1.70361455",
    id: "Fill-3",
    fill: "#E9A22F",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3320938,28.4284 C15.2670938,28.4284 14.4036563,27.5349455 14.4036563,26.4334909 C14.4036563,25.3320364 15.2670938,24.4376364 16.3320938,24.4376364 C17.3970938,24.4376364 18.2605313,25.3320364 18.2605313,26.4334909 C18.2605313,27.5349455 17.3970938,28.4284 16.3320938,28.4284 M19.9067812,1.43 L2.03990625,12.1032364 C0.77803125,12.8577091 -9.375e-05,14.2513091 -9.375e-05,15.7602545 L-9.375e-05,37.1067273 C-9.375e-05,38.6147273 0.77803125,40.0083273 2.03990625,40.7628 L19.9067812,51.4360364 C20.5545938,51.8227273 21.2802187,52.0099273 22.0030312,51.9999378 L22.0030312,0.866968334 C21.2802187,0.856109091 20.5545938,1.04330909 19.9067812,1.43",
    id: "Fill-6",
    fill: "#1B397B",
    mask: "url(#mask-6)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8f83126d.svg";
export { ForwardRef as ReactComponent };